import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { cores } from '../../../../styles/styleUtils';

const KPIBoxStyled = styled.div`
  background-color: ${cores.chumbo};
  color: white;
  padding: 12px 18px;
  border-radius: 25px; // Highly rounded corners
  text-align: center;
  font-size: 0.95rem;
  font-weight: 500;
  white-space: nowrap; // Prevent text wrapping
  overflow: hidden;
  text-overflow: ellipsis; // Add ellipsis if text is too long
`;

const Label = styled.span`
    margin-right: 5px;
    opacity: 0.9; // Slightly less prominent label
`;

const Value = styled.span`
    font-weight: 700;
`;


function KPIBox({ label, value }) {
  return (
    <KPIBoxStyled>
        <Label>{label}</Label>
        <Value>{value}</Value>
    </KPIBoxStyled>
  );
}

KPIBox.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

export default KPIBox;